import * as React from "react";
import { Check, Lock } from "lucide-react";
import { PLAN_FEATURES } from "./plan-features";

function Cell({ value }: { value: boolean | string }) {
  if (value === false) {
    return <Lock className="w-4 h-4 text-gray-300 mx-auto" aria-label="Not included" />;
  }
  return (
    <span className="inline-flex flex-col items-center gap-0.5">
      <Check className="w-[18px] h-[18px] text-leaf-600 mx-auto" strokeWidth={3} aria-label="Included" />
      {typeof value === "string" && (
        <span className="text-[9.5px] font-semibold text-gray-400 leading-tight text-center">{value}</span>
      )}
    </span>
  );
}

/** Basic vs Premium feature matrix (used on the FeatureLock locked-page screen). */
export function PlanComparison() {
  return (
    // Outer rounded border lives on the container so the corners render cleanly;
    // cells only draw the INTERNAL grid lines (row + column dividers).
    <div className="rounded-2xl border border-gray-200 overflow-hidden bg-white">
      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-lavender-50/60">
            <th className="border-b border-gray-200 px-4 py-3 text-left text-[12px] font-extrabold text-navy-500">Feature</th>
            <th className="border-b border-l border-gray-200 px-2 py-3 w-[72px] text-center text-[12px] font-extrabold text-gray-500">Basic</th>
            <th className="border-b border-l border-gray-200 px-2 py-3 w-[88px] text-center text-[12px] font-extrabold text-cj-800 bg-lavender-100/70">Premium</th>
          </tr>
        </thead>
        <tbody className="[&>tr:last-child>td]:border-b-0">
          {PLAN_FEATURES.map((f) => (
            <tr key={f.name} className="hover:bg-lavender-50/30">
              <td className="border-b border-gray-200 px-4 py-2.5 text-[12.5px] font-semibold text-navy-500">{f.name}</td>
              <td className="border-b border-l border-gray-200 px-2 py-2.5 text-center align-middle"><Cell value={f.basic} /></td>
              <td className="border-b border-l border-gray-200 px-2 py-2.5 text-center align-middle bg-lavender-50/50"><Cell value={f.premium} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
